// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"63":"90640f98","580":"17d41b5e"}[chunkId] + ".chunk.js");